exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.item_right_text {\r\n  position: absolute;\r\n  right: 15px;\r\n  top: 50%;\r\n  -webkit-transform: translateY(-50%);\r\n          transform: translateY(-50%);\r\n  color: #c8c8cd;\n}\n.workbench-item:active {\r\n  background: #ececec;\n}\r\n", ""]);

// exports
